import { useMemo } from 'react';
import { Box, Grid, Typography } from '@mui/material';

export const targetAudiencesLabel = {
  KIDS: 'Infantil - até 06 anos',
  CHILDREN: 'Infantil - até 10 anos',
  TEENAGER: 'Adolescente',
  ADULT: 'Adulto',
  ELDERLY: 'Idoso',
};

export const targetAudiencesKeys = [
  'ALL',
  'ADULT',
  'ELDERLY',
  'TEENAGER',
  'CHILDREN',
  'KIDS',
];

export const visibilities = {
  EVERYONE: 'Todos',
  INTERNAL_USERS: 'Apenas usuário interno',
  AUTHENTICATED_USERS: 'Apenas usuário autenticado',
};

export const AppListSummary = ({ list, padding }) => {
  const countsTargetAudience = useMemo(
    () =>
      list &&
      list.reduce((acc, obj) => {
        if (obj.targetAudiences?.length === 4) {
          acc.ALL = acc.ALL || 0;
          acc.ALL += 1;
        } else {
          obj.targetAudiences?.forEach(item => {
            acc[item.code] = acc[item.code] || 0;
            acc[item.code]++;
          });
        }

        return acc;
      }, {}),
    [list]
  );

  const countsVisibility = useMemo(
    () =>
      list &&
      list.reduce((acc, obj) => {
        acc[obj.visibility] = acc[obj.visibility] || 0;
        acc[obj.visibility]++;

        return acc;
      }, {}),
    [list]
  );

  if (!list) return null;

  const Title = ({ children }) => (
    <Typography fontSize={12} variant="subtitle2">
      {children}
    </Typography>
  );

  const DescriptionItem = ({ name, count }) => (
    <Typography as="span" sx={{ padding: 1 }} fontSize={12} variant="body2">
      {name}: {count || 0}
    </Typography>
  );

  const Divider = () => (
    <Box
      as="span"
      sx={{
        borderRight: 'solid 1px #303030',
        maxHeight: '5px',
      }}
    />
  );

  return (
    <Box
      sx={{
        padding: padding ?? '10px 24px',
        background: '#F9FAFB',
      }}>
      <Grid container>
        <Grid item xs="auto">
          <Title>Quantidade de itens por Público Alvo</Title>
          {targetAudiencesKeys.map((targetAudienceKey, index, all) => (
            <>
              <DescriptionItem
                name={targetAudiencesLabel[targetAudienceKey] || 'Todos'}
                count={countsTargetAudience[targetAudienceKey]}
              />
              {index !== all?.length - 1 && <Divider />}
            </>
          ))}
        </Grid>
        <Grid item xs="auto" pt={1}>
          <Title>Quantidade de itens por Visibilidade</Title>
          {Object.keys(visibilities).map((visibilityKey, index, all) => (
            <>
              <DescriptionItem
                name={visibilities[visibilityKey]}
                count={countsVisibility[visibilityKey]}
              />
              {index !== all?.length - 1 && <Divider />}
            </>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};
